export default __webpack_public_path__ + "static/media/Returns-&-Refunds.14e397aa.jpg";